<script setup lang="ts">
defineProps<{ open: boolean }>();
defineEmits<{ click: [] }>();
</script>

<template>
  <button
    type="button"
    class="pl-r4 py-r4 lg:cursor-pointer"
    @click="$emit('click')"
  >
    <div class="relative h-6 w-8 select-none">
      <div
        v-for="i in 4"
        :id="`burger-line-${i}`"
        :key="i"
        :class="{
          'top-0': i === 1 && !open,
          'top-2': i === 2 || i === 3,
          'top-4': i === 4 && !open,
          'rotate-45': open && i === 2,
          '-rotate-45': open && i === 3,
          'top-2 left-1/2 w-0!': open && (i === 1 || i === 4),
          'left-0': !open,
        }"
        class="bg-client-white absolute h-1 w-full rounded-full transition-all duration-300 select-none"
      ></div>
    </div>
  </button>
</template>
